/**
 * 模組頁面代碼:
 * 模組說明: 版權所有
 * @module CopyrightContainer
 */

// ----- import from npm modules -----
import parse from 'html-react-parser';

// ----- import from local libraries -----
import {
    React,
    PropTypes,
    connect,
    BaseComponent,
    AccessModeEnums,
} from '../../../components/BaseComponent';

// ----- import from local components -----
import Header from './Header';
import Footer from './Footer';
import ScrollLink from '../../../components/ScrollLink';
import { MessageModal, MessageModalModeEnums } from '../../../components/MessageModal';

// ----- import from local actions -----
import { getCopyRight } from '../../../redux/actions/AccessActions';

class CopyrightContainer extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            message: { mode: MessageModalModeEnums.ERROR, title: '', body: ''},
        };
        this.messageModalRef = React.createRef();
        this.messageModal = null;
        this.toggleMessageModal = this.toggleMessageModal.bind(this);
    }

    toggleMessageModal(isShow, mode = MessageModalModeEnums.ERROR, title = '', message = '請先登入') {
        if (this.messageModal) {
            if (isShow) {
                let body = message;
                const statusCode = message?.code || '';
                if (statusCode !== '') {
                    body = `[ ${statusCode} ] ${message.message}`;
                }
                this.setState({ message: { mode: mode, title: title, body: body }});
                this.messageModal.show();
            } else {
                this.messageModal.hide();
            }
        }
    }

    componentDidMount() {
        this.loadContent();
        this.messageModal = new bootstrap.Modal(this.messageModalRef.current);
    }

    async loadContent() {
        try {
            await this.props.getCopyRight();
        } catch (error) {
            console.error('Error loading copyright content:', error);
        }
    }

    componentWillUnmount() {
        if (this._anchorClickHandlerTarget) {
            this._anchorClickHandlerTarget.removeEventListener('click', this._anchorClickHandler);
        }
        this._anchorClickHandler = null;
        this._anchorClickHandlerTarget = null;
        this.toggleMessageModal(false);
    }

    toggleLoginMessageModal = (isShow) => {
        this.toggleMessageModal(isShow, MessageModalModeEnums.INFO, '登入提示', '請先登入');
    }

    defaultContent() {
        this._anchorClickHandler = (e) => {
            const anchor = e.target.closest('a[href^="#"]');
            if (!anchor) return;
            if (anchor.closest('.gs18-Header__Hamburger')) return;
            // NavLink 會渲染成 <a> 且有 data attributes
            const href = anchor.getAttribute('href') || anchor.getAttribute('to');
            if (!href || href === '#') return;
            // 只支援 id selector
            const target = document.querySelector(href);
            if (target) {
                e.preventDefault();
                const top = target.getBoundingClientRect().top + window.pageYOffset;
                window.scrollTo({ top, behavior: 'smooth' });
            }
        };
        // 建議加在內容區
        const content = document.querySelector('.m__contents');
        if (content) {
            content.addEventListener('click', this._anchorClickHandler);
            this._anchorClickHandlerTarget = content;
        }

        return (
            <section className="static-content">
                <div className="static-content__head">
                    <h2>版權所有</h2>
                    只要您使用本網站，即視同您已同意遵守本條款，故請詳閱本條款內容。<br />
                    <br />
                </div>
                <div className="static-content__body">
                    <div className="static-content__menu">
                        {/*<a href="#"><i className="fa fa-chevron-circle-down"></i>聲明</a>*/}
                        <ScrollLink to="#a01"><i className="fa fa-chevron-circle-down"></i>聲明</ScrollLink>
                        {/*<a href="#a02"><i className="fa fa-chevron-circle-down"></i>授權</a>*/}
                        <ScrollLink to="#a02"><i className="fa fa-chevron-circle-down"></i>授權</ScrollLink>
                        {/*<a href="#a03"><i className="fa fa-chevron-circle-down"></i>著作權</a>*/}
                        <ScrollLink to="#a03"><i className="fa fa-chevron-circle-down"></i>著作權</ScrollLink>
                        {/*<a href="#a04"><i className="fa fa-chevron-circle-down"></i>使用限制</a>*/}
                        <ScrollLink to="#a04"><i className="fa fa-chevron-circle-down"></i>使用限制</ScrollLink>
                        {/*<a href="#a05"><i className="fa fa-chevron-circle-down"></i>損害賠償</a>*/}
                        <ScrollLink to="#a05"><i className="fa fa-chevron-circle-down"></i>損害賠償</ScrollLink>
                        {/*<a href="#a06"><i className="fa fa-chevron-circle-down"></i>免責聲明</a>*/}
                        <ScrollLink to="#a06"><i className="fa fa-chevron-circle-down"></i>免責聲明</ScrollLink>
                    </div>
                    <div className="static-content__items">
                        只要您使用本網站，即視同您已同意遵守本條款，故請詳閱本條款內容。 <br />
                        <br />
                        <div id="a01" className="static-content__item">
                            <h4>聲明</h4>
                            <p>
                                本網站所登載的任何資料均係由台灣三菱電梯股份有限公司（以下簡稱本公司）提供，本公司得未經通知不定時新增或移除網頁內容及服務功能；亦得未經通知不定時修訂本使用條款，並於登載時隨即生效。請定期確認本網站內容及條款內容，若您不同意本使用條款，請停止使用本網站。
                            </p>
                        </div>
                        <div id="a02" className="static-content__item">
                            <h4>授權</h4>
                            <p>當您使用本網站時，即表示您同意遵守本條款及相關法律規定，您應自行負擔任何非經合法授權的行為責任。</p>
                        </div>
                        <div id="a03" className="static-content__item">
                            <h4>著作權</h4>
                            <p>
                                本網站所有內容之著作權皆由本公司享有，未經授權不得重製、竄改、散布。尊重智慧財產權是您應盡的義務，若有違反應自負全責。
                            </p>
                        </div>
                        <div id="a04" className="static-content__item">
                            <h4>使用限制</h4>
                            <p>若違反以下規定，本公司有權視情況採取若干必要措施。</p>
                            <ul className="number_list">
                                <li>不公布或傳送任何誹謗、侮辱、具威脅性、攻擊性、不雅、猥褻、偽造、違反公序良俗或其他不法之文字、圖片或任何形式的檔案。</li>
                                <li>不公布或傳送侵害他人名譽、隱私權、營業秘密、著作權、專利權、智慧財產權之訊息。</li>
                                <li>不傳送或散布任何形式之電腦病毒檔案。</li>
                                <li>不傳送連鎖信函、垃圾郵件或廣告信函。</li>
                                <li>不從事損害、干擾或中斷本網站服務系統之行為。</li>
                            </ul>
                        </div>
                        <div id="a05" className="static-content__item">
                            <h4>損害賠償</h4>
                            <p>
                                若您違反本條款或其他相關之著作權法、民法、刑法法律規定，以致對第三方或本公司造成損害，您同意負擔此損害賠償責任。
                            </p>
                        </div>
                        <div id="a06" className="static-content__item">
                            <h4>免責聲明</h4>
                            <ul className="number_list">
                                <li>
                                    本公司已採取所有合理措施以確保本網站內容之正確性，但並無法保證絕對安全或絕無錯誤、病毒或其它惡意程式。因使用或引用本網站內容引致損失或損害，本公司概不負責。
                                </li>
                                <li>本網站含有第三方的網站連結，使用第三方的網站可能引致之任何損害，本公司概不予任何擔保或承諾。</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    render() {
        const { copyright } = this.props;
        const isNotEmptyObject = copyright && Object.keys(copyright).length > 0;

        return (
            <React.Fragment>
                <Header toggleLoginMessageModal={this.toggleLoginMessageModal} />
                <div className="header__Placeholder"></div>
                <div className="m__wrap">
                    <div className="m__contents">
                        {isNotEmptyObject ? (
                            <section className="static-content">
                                {parse(copyright.html)}
                            </section>
                        ) : (
                            this.defaultContent()
                        )}
                    </div>
                </div>
                <Footer />
                <MessageModal
                    ref={this.messageModalRef}
                    mode={this.state.message.mode}
                    title={this.state.message.title}
                    message={this.state.message.body}
                />
            </React.Fragment>
        );
    }
}

CopyrightContainer.propTypes = {
    copyright: PropTypes.object,
};

CopyrightContainer.defaultProps = {
    copyright: {},
};

function mapStateToProps(state) {
    return {
        copyright: state.access.copyright,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getCopyRight: () => {
            return dispatch(getCopyRight());
        },
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(CopyrightContainer);
